var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolioBurgundy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".folio-burgundy_svg__folioby2{fill:#97144d}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "folio-burgundy_svg__folioby2",
    d: "M12.858 2.057a.47.47 0 00-.47.47v8.454a.47.47 0 00.47.47h8.454a.47.47 0 00.47-.47 8.934 8.934 0 00-8.924-8.924z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "folio-burgundy_svg__folioby2",
    d: "M19.433 12.39h-7.984V4.406a.47.47 0 00-.47-.47 8.924 8.924 0 108.924 8.924.47.47 0 00-.47-.47zm-8.924 8.44a7.985 7.985 0 010-15.942zm.939 0v-7.5h7.5a8 8 0 01-7.5 7.5z"
  })));
}
export default SvgFolioBurgundy;